import React from 'react';
import Diagram from './Diagram';
import Text from './Text';
import Bottom from './Bottom';
import content from '../content/content.js';
import { Swipeable } from 'react-swipeable';

// google tag manager
import TagManager from 'react-gtm-module';
const tagManagerArgs = {gtmId: 'GTM-NCGQVKQ'}

export default class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      direction: 'next',
      city1: 8, // Genf
      city2: 0, // Amsterdam
      zoom: 100,
      activeProf: 'all'
    }

    this.updateState = this.updateState.bind(this);

    this.swipedDown = this.swipedDown.bind(this);
    this.swipedUp = this.swipedUp.bind(this);
    this.swipedLeft = this.swipedLeft.bind(this);
    this.swipedRight = this.swipedRight.bind(this);
  }

  componentDidMount() {
    // console.log('mounted');
    
    // google tag manager
    TagManager.initialize(tagManagerArgs);

  }

  componentWillUnmount() {
    // console.log('unmounted');
  }

  componentDidUpdate() {
    // console.log('updated');
  }

  // update states

  updateState(up){
    var a = this.state.activeProf;
    var p = this.state.page;
    var c1 = this.state.city1;
    var c2 = this.state.city2;

    // update active profession
    if (up.s === 'activeProf') {
        if (a !== up.v && p > 2) {
          this.setState({ activeProf: up.v })
        } else {
          this.setState({ activeProf: 'none' })
        }

    // update page number
    } else if (up.s === 'page') {
      if ((up.v === 1) && (p < content.pages.length)) {
        this.setState({
          page: p + up.v,
          direction: 'next'
        })
      } else if ((up.v === -1) && (p > 0)) {
        this.setState({
          page: p + up.v,
          direction: 'prev'
        })
      }

    // update city1
    } else if (up.s === ('city1')) {
      if (up.v === 'next') {
        if (c1 < 42) {
          this.setState({city1: c1 + 1})
        } else {
          this.setState({city1: 0})
        }
      } else if (up.v === 'prev') {
        if (c1 > 0) {
          this.setState({city1: c1 - 1})
        } else {
          this.setState({city1: 42})
        }
      } else if (up.v !== -1) {
        this.setState({city1: up.v})
      }

    // update city2
  } else if (up.s === ('city2')) {
      if (up.v === 'next') {
        if (c2 < 42) {
          this.setState({city2: c2 + 1})
        } else {
          this.setState({city2: 0})
        }
      } else if (up.v === 'prev') {
        if (c2 > 0) {
          this.setState({city2: c2 -1})
        } else {
          this.setState({city2: 42})
        }
      } else if (up.v !== -1) {
        this.setState({city2: up.v})
      }

    // default
    } else {
      console.log('no state update possible');
    }

    // additional: page 0 + 1 activePro = 'all'
    if ((p === 0) || (p === 1)) {
      this.setState({ activeProf: 'all' })
    }

  }

  swipedUp(event) {
    var w = window.innerWidth;
    var s = this.state;
    if (s.page === 4) {
      s.city1 === 0 ? this.setState({city1: 42}) : this.setState({city1: s.city1 - 1})
    } else if (s.page === 6 || s.page === 8) {
      if (event.initial[0] < w/2) {
        s.city1 === 0 ? this.setState({city1: 42}) : this.setState({city1: s.city1 - 1})
      } else {
        s.city2 === 0 ? this.setState({city2: 42}) : this.setState({city2: s.city2 - 1})
      }
    }
  }

  swipedDown(event) {
    var w = window.innerWidth;
    var s = this.state;
    if (s.page === 4) {
      s.city1 === 42 ? this.setState({city1: 0}) : this.setState({city1: s.city1 + 1})
    } else if (s.page === 6 || s.page === 8) {
      if (event.initial[0] < w/2) {
        s.city1 === 42 ? this.setState({city1: 0}) : this.setState({city1: s.city1 + 1})
      } else {
        s.city2 === 42 ? this.setState({city2: 0}) : this.setState({city2: s.city2 + 1})
      }
    }
  }

  swipedLeft(e) {
    if (this.state.page === 9) {
      this.setState({
        page: 0,
        direction: 'next'
      })
    } else {
      this.setState({
        page: this.state.page + 1,
        direction: 'next'
      })
    }

  }

  swipedRight(e) {
    if (this.state.page) { // is not 0
      this.setState({
        page: this.state.page - 1,
        direction: 'prev'
      })
    }
  }


  // R E N D E R

  render() {
    var p = this.state.page;
    var d = this.state.direction;
    var z = this.state.zoom;
    var a = this.state.activeProf;
    var c1 = this.state.city1;
    var c2 = this.state.city2;
    var c = content.pages;
    var cts = content.general.cities;

    // page.city ? page.city : state.city
    var c1name, c2name, c1index, c2index;

    if ((c[p].city1 !== 'no') && (c[p].city1 !== 'explore')) {
      c1name = c[p].city1;
      c1index = cts.findIndex(city => city === c[p].city1);
    } else {
      c1name = cts[c1];
      c1index = c1;
    }

    if ((c[p].city2 !== 'no') && (c[p].city2 !== 'explore')) {
      c2name = c[p].city2
      c2index = cts.findIndex(city => city === c[p].city2);
    } else {
      c2name = cts[c2];
      c2index = c2;
    }

    // page 1 ? a = all : a = this.state.active.prof;
    if (p < 3) {
      a = 'all';
    };

    return (
      <Swipeable
        onSwipedUp={this.swipedUp}
        onSwipedDown={this.swipedDown}
        onSwipedLeft={this.swipedLeft}
        onSwipedRight={this.swipedRight} >
        <div className="App">

          <Text
            show={c[p].text}
            prev={(p > 0) ? c[p-1].text: undefined}
            next={(p < c.length)  && c[p+1] ? c[p+1].text: undefined}
            direction={d}
            page={p}
          />

          <Diagram
            content={content}
            city1={c1name}
            city2={c2name}
            zoom={z}
            page={p}
            direction={d}
            activeProf={a}
            onChange={this.updateState}
          />

          <Bottom
            cities={content.general.cities}
            page={p}
            direction={d}
            city1={c1index}
            city2={c2index}
            pageCity1={c[p].city1}
            pageCity2={c[p].city2}
            onChange={this.updateState}
            show={c[p]}
            prev={(p > 0) && c[p-1] ? c[p-1] : undefined}
            next={(p < c.length) && c[p+1] ? c[p+1] : undefined}
          />

        </div>
      </Swipeable>

    )
  }
}
